module.exports = __webpack_public_path__ + "static/media/attack.83bd2432.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Obelisk/images/attack.svg
// module id = 1406
// module chunks = 0